<template>
  <BaseModal id="ebay-category-search" :value="true" @input="$emit('input')">
    <input
      v-model="search"
      type="text"
      class="regular bordered full mt-10"
      placeholder="search.."
    />
    <div>
      <p class="my-2">Categories</p>
      <BaseMiniSpinner v-if="loading"></BaseMiniSpinner>
      <div
        v-for="category in categories"
        :key="category.id"
        class="grid-line border my-1 hover:bg-green-100"
        @click="$emit('categorySelected', category)"
      >
        <div>{{ category.partTerminologyName }}</div>
        <div>{{ category.ebayLeafCatName }}</div>
        <div>{{ category.categoryId }}</div>
        <div>{{ category.breadcrumb }}</div>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import { getEbayCategories } from "@/api/store/EbayCategoriesService.js";
export default {
  name: "ebayCategorySearch",
  data() {
    return {
      search: "",
      categories: [],
      currentApiCallId: null,
      loading: false
    };
  },
  watch: {
    search() {
      this.searchCategories();
    }
  },
  methods: {
    async searchCategories() {
      this.loading = true;
      this.currentApiCallId = new Date();
      let apiId = this.currentApiCallId;
      const res = await getEbayCategories(this.search).catch(() => {
        console.log("Error getting Products");
      });
      if (apiId === this.currentApiCallId) {
        this.categories = res;
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="postcss">
.grid-line {
  display: grid;
  grid-template-columns: 180px 180px 60px 1fr;
}
.grid-line div {
  @apply p-1 flex justify-center items-center text-center cursor-pointer;
  border-left: 0.5px solid;
  border-right: 0.5px solid;
}
#ebay-category-search.modal.active {
  padding: 20px;
  display: flex !important;
  justify-content: center !important;
}
#ebay-category-search .modal-content {
  width: 88% !important;
  height: 88% !important;
  padding: 0px !important;
  margin: auto !important;
}
</style>
